<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Rakhi making Competition</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="">
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                  <p>Crafting creativity! GHRCACS, Nagpur's Nature Nurturers Club, organised a Rakhi Making Competition, where students showcased their artistic skills by creating stunning rakhis. A beautiful blend of tradition and imagination, this event brought festive joy to life.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-2.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-2.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-3.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-3.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-4.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-4.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-5.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-5.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                
              </div>
        </div>
    </div>
</section>